import React from 'react'
import { Box, Dialog, DialogContent, Divider, Typography } from '@mui/material'

import { LoadingButton } from '@mui/lab'
import { BootstrapDialogTitle } from '.'
import { SxProps, Theme } from '@mui/system'

interface AlertModalProps {
  open: boolean
  modalType: string
  title: string
  question: string
  description: string | object
  confirmLabel?: string
  cancelLabel?: string
  onSubmit: () => void
  onClose: () => void
  showIsLoading?: boolean
  secondaryActionLabel?: string
  onSecondaryAction?: () => void
  height?: number
  buttonBoxWidth?: number | string
}

const AlertModal: React.FC<AlertModalProps> = ({
  open,
  modalType,
  title,
  question,
  description,
  confirmLabel = 'Yes',
  cancelLabel = 'Stay here',
  onSubmit,
  onClose,
  showIsLoading = false,
  secondaryActionLabel,
  onSecondaryAction,
  height = 356,
  buttonBoxWidth = '50%',
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="confirm-dialog-title"
    sx={{
      '& .MuiDialog-paper': {
        width: 500,
        height: modalType !== 'payment' ? height : 200,
      },
    }}
  >
    <BootstrapDialogTitle id="confirm-dialog-title" onClose={onClose}>
      {title}
    </BootstrapDialogTitle>

    {modalType !== 'payment' && <Divider />}

    <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        px={modalType !== 'payment' ? 2 : undefined}
        display="flex"
        justifyContent={modalType === 'payment' ? 'left' : 'center'}
        alignItems="center"
        flex={1}
      >
        <Typography id="modal-modal-question" variant={modalType === 'payment' ? 'inherit' : 'h6'} align="center">
          {question}
        </Typography>
      </Box>

      {modalType !== 'payment' && description && (
        <Box px={2} display="flex" justifyContent="center" alignItems="center" flex={1}>
          <Typography variant="body1" align="center">
            {description}
          </Typography>
        </Box>
      )}
    </DialogContent>

    <Box
      py={1}
      display="flex"
      flexDirection={modalType !== 'payment' ? 'column' : 'row-reverse'}
      sx={{ width: modalType !== 'payment' ? buttonBoxWidth : '100%', margin: 'auto' }}
      justifyContent="flex-start"
      paddingRight={modalType !== 'payment' ? 0 : 2}
    >
      {secondaryActionLabel ? (
        <LoadingButton
          color={modalType === 'payment' || modalType === 'ship' ? 'success' : 'error'}
          size="large"
          variant="outlined"
          onClick={onSecondaryAction}
          loading={showIsLoading}
          sx={{ mb: modalType === 'payment' ? 0 : 1 }}
        >
          {secondaryActionLabel}
        </LoadingButton>
      ) : null}
      <LoadingButton
        color={modalType === 'payment' || modalType === 'ship' ? 'success' : 'error'}
        size="large"
        variant="contained"
        onClick={onSubmit}
        loading={showIsLoading}
        sx={{ mb: modalType === 'payment' ? 0 : 1 }}
      >
        {confirmLabel}
      </LoadingButton>
      <LoadingButton
        color={modalType !== 'payment' ? 'error' : 'success'}
        size="large"
        autoFocus
        onClick={onClose}
        loading={showIsLoading}
      >
        {cancelLabel}
      </LoadingButton>
    </Box>
  </Dialog>
)

export default AlertModal
